import { forwardRef, type Ref, type SVGProps } from "react";

function SvgTiersWindowedOut(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={124}
      height={118}
      fill="none"
      {...props}
    >
      <path
        stroke="url(#TiersWindowedOut_svg__a)"
        strokeWidth={10}
        d="M40.286 48.333v-16C40.286 20.551 50.007 11 62 11s21.714 9.551 21.714 21.333V37.5M34.857 107h54.286C95.139 107 100 102.224 100 96.333V59c0-5.891-4.86-10.667-10.857-10.667H34.857C28.861 48.333 24 53.11 24 59v37.333C24 102.224 28.86 107 34.857 107Z"
      />
      <path stroke="#0C1C43" strokeLinecap="round" d="M62 68v14" />
      <path
        fill="#D3A136"
        d="m3.145 13.502 10.63-5.848a1.24 1.24 0 0 1 1.2 0l10.63 5.848a1.245 1.245 0 0 1 .425 1.796L15.4 30.713a1.244 1.244 0 0 1-2.047 0L2.72 15.298a1.244 1.244 0 0 1 .425-1.796"
      />
      <defs>
        <linearGradient
          id="TiersWindowedOut_svg__a"
          x1={62}
          x2={62}
          y1={11}
          y2={107}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7C649" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTiersWindowedOut);
export default ForwardRef;
